<form *ngIf="form" [formGroup]="form">

  <section fxLayout="row wrap">
    <div class="access-per-pon" fxFlex="25">
      <mat-form-field appearance="outline">
        <mat-label i18n>Access per PON</mat-label>
        <input #accessPerPon type="number" matInput formControlName="accessPerPon">
      </mat-form-field>
      <div>
        <app-suggestion [input]="accessPerPon" [options]="[32, 64, 128]"
          (changeSelection)="this.form.patchValue({accessPerPon: $event})">
        </app-suggestion>
      </div>
    </div>
    <div class="sections" fxFlex="50">
      <h3 i18n>Splitter sections</h3>
      <app-input-array #sectionsInput [values]="sections" (valuesChange)="sectionsChange($event)" label="Section"
        i18n-label>
        <mat-error *ngIf="sectionsError else sectionEmptyBlock" i18n>
          The splitter sections does not match with Access PON
        </mat-error>
      </app-input-array>
      <app-suggestion *ngIf="sectionsInput.index != null" [options]="allowedSplitterValues"
        (changeSelection)="sections[sectionsInput.index] = $event">
      </app-suggestion>
    </div>
    <div class="attendance-splitter" fxFlex="25">
      <mat-form-field appearance="outline">
        <mat-label i18n>Attendance splitter</mat-label>
        <input #attendanceSplitter formControlName="attendanceSplitter" matInput>
      </mat-form-field>
      <div>
        <app-suggestion [input]="attendanceSplitter" [options]="allowedSplitterValues"
          (changeSelection)="this.form.patchValue({attendanceSplitter: $event})">
        </app-suggestion>
      </div>
    </div>
  </section>

  <section>
    <h3>Overbooking</h3>
    <div fxLayout="row wrap">
      <div fxFlex="25">
        <mat-form-field appearance="outline">
          <input type="number" matInput formControlName="overbooking">
          <span matSuffix>%</span>
        </mat-form-field>
      </div>
      <div fxFlex="100"></div>
      <mat-slider class="overbooking-slider" fxFlex="25" [value]="this.form.value.overbooking"
        (input)="this.form.patchValue({overbooking: $event.value})" tickInterval="1" step="1" min="0" max="100">
      </mat-slider>
    </div>
  </section>

  <section fxLayout="row wrap">
    <h3 fxFlex="100" i18n>Customer connection</h3>
    <mat-form-field appearance="outline" fxFlex="25">
      <mat-label i18n>Max length drop cable</mat-label>
      <input #maxDropLength type="number" formControlName="max_drop_length" matInput>
      <mat-hint i18n>Meters</mat-hint>
    </mat-form-field>
    <div fxFlex></div>
    <div fxFlex="100">
      <app-suggestion [input]="maxDropLength" [options]="['80', '100', '120', '150']"
        (changeSelection)="this.form.patchValue({max_drop_length: $event})">
      </app-suggestion>
    </div>

  </section>

  <section>
    <h3 i18n>Box-Drop</h3>
    <mat-button-toggle-group formControlName="connector_box_drop" class="options">
      <mat-button-toggle value="factory_connector" i18n>FACTORY</mat-button-toggle>
      <mat-button-toggle value="field_connector" i18n>FIELD</mat-button-toggle>
      <mat-button-toggle value="fusion" i18n>FUSION</mat-button-toggle>
    </mat-button-toggle-group>

    <app-fiber-connection [form]="form" [settings]="parameters.horizontal_settings"></app-fiber-connection>
  </section>

</form>

<ng-template #sectionEmptyBlock>
  <mat-hint i18n>Optional</mat-hint>
</ng-template>
